export const MODULE = "BTAX";

export const SEARCH_BILLING = `${MODULE}/search_billing`;
export const CREATE = `${MODULE}/create_btax`;
export const INQUIRE_YEARS = `${MODULE}/inquire_years`;
